import { TaskModel } from "@teamprevent/common/task/taskActions/models";
import { DropdownOption } from "@teamprevent/common/questionnaires/model";

export interface UpdateVideoMeetingTaskSuccessResult {
    videoAppointmentTaskDto: TaskModel;
}

export interface UnableToBookVideoConsultationRequestModel {
    justification: string;
}

export interface MarkVideoConsultationAsUnableBookSuccessResult {
    tasks: TaskModel[];
}

export interface CompleteCreateVideoConsultationSuccessResult {
    completeCreateVideoConsultationTaskDto: TaskModel;
}

export enum UnableToBookVideoAppointmentsReasons {
    AppointmentTimeNotConvenient = "AppointmentTimeNotConvenient",
    EmployeeDidNotWantVideoAppointmentFaceToFacePreferred = "EmployeeDidNotWantVideoAppointmentFaceToFacePreferred",
    EmployeeDidNotWantVideoAppointmentTelephonePreferred = "EmployeeDidNotWantVideoAppointmentTelephonePreferred",
    EmployeeDoesNotHaveCorrectEquipment = "EmployeeDoesNotHaveCorrectEquipment",
    EmployeeDoesNotWantToUseMicrosoftTeams = "EmployeeDoesNotWantToUseMicrosoftTeams",
    NoTrainedNurseKpiSpace = "NoTrainedNurseKpiSpace",
    OtherPleaseState = "OtherPleaseState",
    ReTriagedOrLateTriage = "ReTriagedOrLateTriage",
    UnableToContactTelephoneAppointmentAllocated = "UnableToContactTelephoneAppointmentAllocated"
}

export const unableToBookVideoAppointmentsReasonsOptions: DropdownOption[] = [
    {
        text: "Appointment time not convenient",
        value: UnableToBookVideoAppointmentsReasons.AppointmentTimeNotConvenient
    },
    {
        text: "Employee did not want video appointment - Face to Face preferred",
        value: UnableToBookVideoAppointmentsReasons.EmployeeDidNotWantVideoAppointmentFaceToFacePreferred
    },
    {
        text: "Employee did not want video appointment - Telephone preferred",
        value: UnableToBookVideoAppointmentsReasons.EmployeeDidNotWantVideoAppointmentTelephonePreferred
    },
    {
        text: "Employee does not have correct equipment",
        value: UnableToBookVideoAppointmentsReasons.EmployeeDoesNotHaveCorrectEquipment
    },
    {
        text: "Employee does not want to use MS Teams",
        value: UnableToBookVideoAppointmentsReasons.EmployeeDoesNotWantToUseMicrosoftTeams
    },
    {
        text: "No trained nurse KPI Space",
        value: UnableToBookVideoAppointmentsReasons.NoTrainedNurseKpiSpace
    },
    {
        text: "Other - Please state",
        value: UnableToBookVideoAppointmentsReasons.OtherPleaseState
    },
    {
        text: "Re-triaged or late triage",
        value: UnableToBookVideoAppointmentsReasons.ReTriagedOrLateTriage
    },
    {
        text: "Unable to contact - Telephone appointment allocated",
        value: UnableToBookVideoAppointmentsReasons.UnableToContactTelephoneAppointmentAllocated
    }
];
